export const GRE_BANNER_MAX_SIZE_BYTES = 5 * 1024 * 1024;

export const GRE_BANNER_ALLOWED_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
];

const GRE_BANNER_ALLOWED_EXTENSIONS = /\.(jpe?g|png|webp)$/i;

export function formatGreBannerMaxSizeMb() {
  return `${GRE_BANNER_MAX_SIZE_BYTES / (1024 * 1024)} MB`;
}

export function validateGreBannerFile(file, messages = {}) {
  if (!file) {
    return { valid: false, error: messages.required || "Please choose an image." };
  }

  const mimeOk = GRE_BANNER_ALLOWED_MIME_TYPES.includes(file.type);
  const extOk = GRE_BANNER_ALLOWED_EXTENSIONS.test(file.name || "");

  if (!mimeOk && !extOk) {
    return {
      valid: false,
      error:
        messages.invalidFormat ||
        "Only JPEG, PNG, or WebP images are allowed.",
    };
  }

  if (file.size > GRE_BANNER_MAX_SIZE_BYTES) {
    return {
      valid: false,
      error:
        messages.fileTooLarge ||
        `Image must be ${formatGreBannerMaxSizeMb()} or smaller.`,
    };
  }

  return { valid: true, error: "" };
}
